(() => {
  const label = 'Pay with Debit / Credit Card';

  const refreshNativeCheckoutLabels = (root = document) => {
    root.querySelectorAll('.shopify-payment-button__more-options').forEach((link) => {
      if (link.textContent.trim() !== label) link.textContent = label;
      link.setAttribute('aria-label', `${label} through Shopify Checkout`);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    refreshNativeCheckoutLabels();
    new MutationObserver(() => refreshNativeCheckoutLabels())
      .observe(document.documentElement, { childList: true, subtree: true });
  });
})();
